<template>
	<div id="ssr_root">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h1 class="page-title">{{ page_title }} <small class="hidden-sm hidden-xs"><a href="#" @click.prevent="view_city = !view_city">{{ $t("change_city") }}</a></small></h1>
                </div>
            </div>
        </div>
        <div class="ovf_row row visible-sm visible-xs m-b-20">
            <div class="col-xs-12">
                <a href="#" @click.prevent="view_city = !view_city">{{ $t("change_city") }}</a>
                <div class="pull-right">
                    <button v-if="location" class="btn btn-icon btn-default waves-effect waves-light" @click="openMapSearch()" type="button">
                        <i class="far fa-map"></i>
                        {{$t('view_map')}}
                    </button>
                </div>
            </div>
        </div>
		<div class="row">
            <div class="col-xs-12 m-b-30" v-if="(view_city || (location == '' || location == null))">
				<location-search :ptype="type" :plocation="$store.state.city_name" inline-template>
					<div class="city_search">
						<p class="h5 m-b-10 text-muted">{{ $t("enter_the_name_of_the_city_where_you_are_looking") }}</p>
						<div class="form-inline" v-bind:class="{'has-error': locationError}" id="form_search">
							<city-autocomplete
								name="location_input"
								ref="location"
								id="location"
								classname="form-control"
								:placeholder="$t('enter_the_name_of_the_city_where_you_are_looking')"
								:value="location"
								v-on:placechanged="getLocation"
                                v-on:preselect="preSelectItem">
							</city-autocomplete>
							<button id="city-autocomplete-btn" data-style="slide-left" @click="searchLocation()" ref="sbm_btn" class="btn btn-custom btn-bordered waves-effect waves-light ladda-button">
								<span class="ladda-label"><i class="fas fa-search m-r-5"></i> {{ $t("search") }}</span>
							</button>
						</div>
					</div>
				</location-search>
            </div>
			<no-ssr>
				<div class="col-xs-12 m-b-20">
                    <div class="filters_cnt">
                        <search-filter @filterResults="filterResults()"></search-filter>
                    </div>

					<div class="pull-right hidden-sm hidden-xs">
						<button v-if="location" class="btn btn-icon btn-default waves-effect waves-light" @click="openMapSearch()" type="button">
							<i class="far fa-map"></i>
							{{$t('view_map')}}
						</button>
					</div>
				</div>
			</no-ssr>

            <div class="col-xs-12 m-b-30">
                <sponsored-ads :location="location"></sponsored-ads>
            </div>

			<div class="col-xs-12" itemscope itemtype="http://schema.org/ItemList">
				<vue-simple-spinner v-if="loading"></vue-simple-spinner>
				<div class="text-center" v-if="properties.length == 0 && loading == false">
					<span>{{ $t("no_items_found") }}</span>
				</div>
				<div class="row">
					<div itemprop="itemListElement" itemscope itemtype="http://schema.org/Accommodation"
						v-for="(ad, index) in properties" v-bind:key="ad.id" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <meta itemprop="name" :content="ad.title">
                        <meta itemprop="position" :content="index">
                        <meta itemprop="url" :content="ad.url">
                        <meta itemprop="image" :content="ad.main_photo">
                        <meta itemprop="address" :content="ad.location">
						<property-ad-card :ad="ad" :index="pagination.from + index"></property-ad-card>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="text-center">
					<vue-pagination v-bind:pagination="pagination"></vue-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<i18n src="../../../lang/components/search/property-results.json"></i18n>

<script>
	import NoSSR from 'vue-no-ssr';
	import SimpleSpinner from '../spinner/Spinner.vue';
    import Pagination from '../pagination/pagination.vue';
    import SponsoredAds from './sponsored-ads.vue';
    import PropertyAdCard from './property-ad-card.vue'
    let urlParams = require('../mixins/url-params.js');

	export default {
        mixins: [urlParams],
		components: {
			'no-ssr': NoSSR,
			'vue-simple-spinner': SimpleSpinner,
            'vue-pagination': Pagination,
            'sponsored-ads': SponsoredAds,
            'property-ad-card': PropertyAdCard
		},
		data: function () {
			return {
                view_city: false,
				loading: false,
				sorts: ['relevant', 'recent']
			};
		},
		computed: {
			sort: function () {
				return this.$store.getters.getSort;
			},
			properties: function () {
				return this.$store.getters.getAds;
			},
			pagination: function () {
				return this.$store.getters.getPagination;
			},
			location: function () {
				return this.$store.state.location;
			},
			type: function () {
				return this.$store.state.type;
            },
            filter: function () {
                return this.$store.state.filter;
            },
            district: function () {
                return this.$store.getters.getDistrict;
            },
            districts: function () {
                return this.$store.getters.getDistricts;
            },
            page_title: function () {
                return this.$store.getters.getPageTitle;
            }
		},
		methods: {
			openMapSearch: function () {
				let url = '/search-map';
				if (this.type !== '' && typeof this.type !== typeof undefined) {
                    url = url + '/' + this.type;
				}

                if (this.location !== '' && typeof this.location !== typeof undefined) {
					url = url + '/' + this.location;
				}

				location.href = url;
			},
			setSort: function (value) {
				this.$store.commit('setSort', value);
				EventBus.$emit('set_search_sort', value);
            },
            filterResults() {
                var _this = this;

				let f = _.clone(this.filter);
				f.sort = this.sort;

                let query = this.getUrlQuery(this.filter, true);
				var obj = {
					type: this.type,
					location: this.location,
					district: this.district.join('|'),
					query: query,
					sort: this.sort,
				};

				obj.filter = _.clone(this.filter); // Use lodash clone to avoid passing the references from the filter object.

				if (this.filter.price_range[0] == 0 && this.filter.price_range[1] == 15000)
					delete obj.filter.price_range;

                this.loadingResults();

				axios.post('/search/filter', obj).then(function (response) {
					if (response.status == 200) {
                        _this.$store.commit('setAds', response.data.data);
                        _this.$store.commit('setPagination', response.data.meta);
                        _this.loading = false;
                    } else
						$.App.error(this.$t('error_message'));
				}).catch(function (err) {
                    _this.loading = false;
				    $.App.error(this.$t('error_message'));
				});
            },
            loadingResults() {
                this.$store.commit('setAds', []);
				this.$store.commit('setPagination', {});
				this.loading = true;
			},
		},
	}
</script>
